// Third party
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// Hooks
import { WelcomeController } from '../../../services';

// Components
import {
  persistor,
  catalogDataActions,
  profileDataActions,
  shootingDataActions,
  vcatKitsDataActions,
  dashboardDataActions,
  managedUsersDataActions,
  accountRootsDataActions,
  billingReportDataActions,
} from '../../../store';
import { queryClient } from '../../../App';

export function useLogoutAPI() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logout = useCallback(async () => {
    try {
      WelcomeController().logout();

      navigate('/login');

      setTimeout(async () => {
        dispatch(shootingDataActions.resetShootingData());
        dispatch(profileDataActions.resetProfileInfo());
        dispatch(dashboardDataActions.resetDashboardData());
        dispatch(catalogDataActions.resetCatalogInfo());
        dispatch(accountRootsDataActions.resetAccountRootsInfo());
        dispatch(vcatKitsDataActions.resetVcatKitsData());
        dispatch(billingReportDataActions.resetBillingReport());
        dispatch(managedUsersDataActions.resetManagedUsers());
        await persistor.purge();

        queryClient.clear();
      }, 50);
    } catch (error) {
      console.error('Logout failed:', error);
    }
  }, [dispatch, navigate]);

  return { logout };
}
